const rail = {
  rails: "Des rails", // translated
  senior: "Senior", // translated
  seniors: "Personnes âgées", // translated
  youths: "Jeunes", // translated
  yearOld: "ans", // translated
  yearsOld: "ans", // translated
};


export default rail;
